import { useGetBriefDeliverables } from "@entities/brief/lib/hooks/useGetBriefDeliverables";
import { useBriefStore } from "@pages/layout/BriefLayout/lib/useLayoutStore";
import { SearchMultiSelectFilter } from "@shared/ui/filters/SearchMultiSelectFilter";
import { useBriefInfluencerFilterStore } from "@widgets/CampaignBrief/store/useBriefInfluencerFilterStore";

interface BriefDeliverablesFilterProps {
  confirm: () => void;
  close: () => void;
  before?: React.ReactNode;
}

export function DeliverableFilter({
  confirm,
  close,
  before,
}: BriefDeliverablesFilterProps) {
  const { briefId } = useBriefStore();

  const { beFilters, setDeliverables, saveFilters, setStatusFilter } =
    useBriefInfluencerFilterStore();

  const {
    deliverables: deliverableOptions,
    isFetching: isFetchingDeliverables,
  } = useGetBriefDeliverables(briefId);

  const deliverableSelectOptions = [
    ...(deliverableOptions || [])?.map((deliverable) => ({
      label:
        deliverable?.deliverableV2?.name ??
        `Package - ${deliverable.deliverableV2.setNumber || ""}`,
      value: deliverable?.deliverableV2?._id || "",
    })),
    {
      label: "Unassigned",
      value: "unassigned",
    },
  ];

  const handleApply = (selectedValues: string[]) => {
    if (selectedValues.includes("unassigned")) {
      setStatusFilter("isPendingDeliverables", true);
    } else {
      setStatusFilter("isPendingDeliverables", false);
    }
    setDeliverables(selectedValues.filter((value) => value !== "unassigned"));
    saveFilters();
  };

  return (
    <SearchMultiSelectFilter
      confirm={confirm}
      close={close}
      before={before}
      options={deliverableSelectOptions}
      selectedValues={[
        ...(beFilters.delivrables || []),
        ...(beFilters.statusFilters?.isPendingDeliverables
          ? ["unassigned"]
          : []),
      ]}
      onApply={handleApply}
      loading={isFetchingDeliverables}
      searchPlaceholder="Search deliverables"
    />
  );
}
